import React from 'react';

const Loader = () => (
  <div className="loading-overlay">
    <div className="loader" />
  </div>
);

export default Loader;
